import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import Orderlines from "./Orderlines";
import editIcon from "../../Images/edit.svg";
import { useSession } from "../../authentications/SessionContext";
import { onChangeSelectOrder } from "../../DataApi/orders/onChandeSelectOrder";
import {
  ADD_SALE_ORDER_DATE_FORMAT,
  ORDER_LINE_DETAIL_KEYS,
  SALE_ORDER_DETAIL_KEYS,
} from "../../utilities/constants";
import { create } from "../../DataApi/create";
import moment from "moment/moment";
import { read } from "../../DataApi/read";
import SVGButton from "../Buttons/SVGButton";
import LoaderWrapper from "../Loader/LoaderWrapper";
import { write } from "../../DataApi/write";
import { useLanguage } from "../LangTranslation/LanguageContext";
import { FieldArray, Form, Formik } from "formik";
import FormikInput from "../Formik/FormikInput";
import FormikSelect from "../Formik/FormikSelect";
import { newSaleOrderValidationSchema } from "../../utilities/Validation Schema/NewSaleFormValidations";
import OtherInfo from "./OtherInfo";
import OptionalProducts from "./OptionalProducts";
import { findAndAddOption } from "../../utilities/findAndAddOption";
import useListOptions from "../../CustomHooks/useListOptions";
import TotalInfo from "./TotalInfo";
import DeliveryInfo from "./DeliveryInfo";
import { FormContainer } from "../StyledComponents/FormConatiner/FormContainerStyle";
import OrderInvoices from "./OrderInvoices";
import useConfirmationModal from "../ConfirmationModal/useConfirmationModal";
import { loadViewGeneral } from "../../DataApi/generalApis/loadViewsGeneral";
import {
  getFormattedResponse,
  getLoadViewsData,
} from "../../utilities/getLoadViewsData";
import { handleResponse } from "../../utilities/handleResponse";
import ButtonSpinLoader from "../ButtonLoader/ButtonSpinLoader";
import useFormikSubmitButton from "../../CustomHooks/useFormikSubmitButton";

const CalculationContainer = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  min-height: 140px;
  border: 1px solid #f3f3f3;


 
  .coupan_prmo_div {
    background-color: #f8f9fa;
    color: #b0b7c3;
    width: 230px;
    min-width: 110px;
    border: none;
    margin-top: 15px;
    border-radius: 15px;
    padding: 10px 20px;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 600;
    text-align: center;

    &:hover,
    &:focus,
    &:active {
      background-color: #ff5837;
      color: #fff;
    }
  }


  @media (max-width: 768px ) {
    .coupan_prmo_div {
      font-size: 10px;
      width: 70px;
    }
  }
 
  .right_side_div {
    padding: 20px;
    font-family: "Inter";
    font-size: 15px;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
  .right_side_amount {
    margin-left: 6px;
    font-size: 15px;
  }
  .total_amount_div {
    color: #ff5837;
  }
  .amount_div {
    margin-left: 26px;
  }
  .tax_div {
    margin-left: 80px;
  } 
  
  }
`;

const Button = styled.button`
  background-color: #f8f9fa;
  color: #b0b7c3;
  width: 280px;
  min-width: 160px;
  border: none;
  border-radius: 15px;
  padding: 10px 20px;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 600;

  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;

  &:hover,
  &:focus,
  &:active {
    background-color: #ff5837;
    color: #fff;
  }
`;

const NewSaleForm = ({ selectedOrder, handleCloseModal }) => {
  const { language, translations } = useLanguage();
  const t = translations[language];
  const { sessionInfo } = useSession();

  // custom hooks

  const { ConfirmationModal, toggleModal, setMetaData, setTitle } =
    useConfirmationModal();

  const { setIsSubmitting, FormikSubmitButtons } = useFormikSubmitButton();

  const {
    handleCustomSearch,
    options: activeCustomersList,
    setOptions: setActiveCustomersList,
  } = useListOptions();
  // states
  const [validations, setValidations] = useState({
    partner_id: "",
  });
  const [invoices, setInvoices] = useState([]);
  const [deliveryOrders, setDeliveryOrders] = useState([]);
  const [isLoadingChange, setIsLoadingChange] = useState(-1);

  const [previousInputs, setPreviousInputs] = useState({});
  const { company_id, context, user_id } = sessionInfo;
  const [isLoading, setIsLoading] = useState(true);
  const [formFieldsList, setFormFieldsList] = useState([]);
  const [view, setView] = useState("view");
  const [paymentTerms, setPaymentTerms] = useState([]);
  const [priceList, setPriceList] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [taxList, setTaxList] = useState([]);
  const [warehouseList, setWarehouseList] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    partner_id: "",
    validity_date: moment().format(),
    date_order: moment().format(),
    partner_invoice_id: "",
    pricelist_id: "",
    partner_shipping_id: "",
    payment_term_id: "",
    payment_status: "",
    order_line: [],
    optional_line: [],
    warehouse_id: "",
  });

  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  const handleChangeCustomer = async ({
    option,
    setFieldValue,
    name,
    values,
  }) => {
    // Update form data
    setFieldValue(name, option.value);
    setValidations({ ...validations, partner_id: "" });

    let response = await onChangeSelectOrder({
      customer_id: option.value,
      context,
      company_id,
      model: "sale.order",
    });
    if (response) {
      response = JSON.parse(response);
    }

    // Extract values from response
    let {
      payment_term_id,
      partner_invoice_id,
      partner_shipping_id,
      currency_id,
      pricelist_id,
    } = response?.result?.value;

    // Update form data with new values

    findAndAddOption({
      incomingOption: partner_invoice_id,
      availableOptions: activeCustomersList,
      setAvailableOptions: setActiveCustomersList,
      keyName: "partner_invoice_id",
      setFieldValue,
    });
    findAndAddOption({
      incomingOption: partner_shipping_id,
      availableOptions: activeCustomersList,
      setAvailableOptions: setActiveCustomersList,
      keyName: "partner_shipping_id",
      setFieldValue,
    });
    findAndAddOption({
      incomingOption: payment_term_id,
      availableOptions: paymentTerms,
      setAvailableOptions: setPaymentTerms,
      keyName: "payment_term_id",
      setFieldValue,
    });
    findAndAddOption({
      incomingOption: pricelist_id,
      availableOptions: priceList,
      setAvailableOptions: setPriceList,
      keyName: "pricelist_id",
      setFieldValue,
    });
    setFieldValue("currency_id", currency_id?.[0] || values?.currency_id);
  };

  const handleChangeProduct = async ({
    option,
    index,
    setFieldValue,
    keyName,
    values,
  }) => {
    setIsLoadingChange(index);
    try {
      let response = await onChangeSelectOrder({
        product_id: option.value,
        context,
        company_id,
        values,
        model: "sale.order.line",
      });
      if (response) {
        response = JSON.parse(response);
      }
      const {
        name,
        product_template_id,
        product_uom,
        price_unit,
        price_subtotal,
        price_tax,
        price_total,
        tax_id: newtaxId,
      } = response?.result?.value || {};
      let tax_id = false;
      if (typeof newtaxId) {
        tax_id =
          newtaxId?.[1]?.length > 1
            ? newtaxId?.[1]?.[newtaxId?.[1]?.length - 1]
            : values.tax_id;
      }
      const newOrderLineData = {
        ...values,
        name: name || values.name,
        product_template_id:
          product_template_id?.[0] || values?.product_template_id || false,
        product_uom: product_uom?.[0] || values?.product_uom || false,
        price_unit: price_unit || values?.price_unit || 0,
        product_id: option.value,
        tax_id: tax_id || false,
        price_total: price_total || values.price_total,
        price_subtotal: price_subtotal || values?.price_subtotal || 0,
        price_tax: price_tax || values?.price_tax || 0,
      };
      findAndAddOption({
        availableOptions: productsList,
        incomingOption: [option.value, option.label],
        setAvailableOptions: setProductsList,
      });

      setFieldValue(`${keyName}.${index}`, newOrderLineData);
      setIsLoadingChange(-1);
    } catch (error) {
      setIsLoadingChange(-1);
    }
  };

  const getPayload = (data) => {
    const orderLineData =
      data?.order_line
        ?.filter((order) => order?.product_id)
        .map((order) => [
          0,
          order.id || `virtual_${parseInt(Math.random() * 1000)}`,
          {
            ...order,
            product_id: order?.product_id || false,
            tax_id: order?.tax_id
              ? [[6, false, [order?.tax_id]]]
              : [[6, false, []]],
          },
        ]) || [];
    let payload = {
      partner_id: data?.partner_id || false,
      partner_invoice_id: data?.partner_invoice_id || false,
      partner_shipping_id: data?.partner_shipping_id || false,
      validity_date:
        moment(data?.validity_date).format(ADD_SALE_ORDER_DATE_FORMAT) || false,
      pricelist_id: data?.pricelist_id || false,
      date_order:
        moment(data?.date_order).format(ADD_SALE_ORDER_DATE_FORMAT) || false,
      payment_term_id: data?.payment_term_id || false,
      warehouse_id: data?.warehouse_id || false,
      order_line: orderLineData || [],
      note: data?.note || "",
      picking_policy: data?.picking_policy || "direct",
      company_id: data?.company_id || company_id,
      // picking_ids: data?.data || [],
      // recompute_delivery_price: data?.recompute_delivery_price || false,
      // sale_order_template_id: data?.sale_order_template_id || false,
      // show_update_pricelist: data?.show_update_pricelist || false,
      // sale_order_option_ids: data?.sale_order_option_ids || [],
      // user_id: user_id,
      // process_manual_confirm: data?.process_manual_confirm || false,
      // team_id: data?.team_id || false,
      // cart_recovery_email_sent: data?.cart_recovery_email_sent || false,
      // require_signature: data?.require_signature || true,
      // require_payment: data?.require_payment || true,
      // client_order_ref: data?.client_order_ref || false,
      // tag_ids: data?.tag_ids || [[6, false, []]],
      // location_map_latitude: data?.location_map_latitude || 0,
      // location_map_longitude: data?.location_map_longitude || 0,
      // location_map_url: data?.location_map_url || false,
      // fiscal_position_id: data?.fiscal_position_id || false,
      // analytic_account_id: data?.analytic_account_id || false,
      // incoterm: data?.incoterm || false,
      // commitment_date: data?.commitment_date || false,
      // origin: data?.origin || false,
      // opportunity_id: data?.opportunity_id || false,
      // campaign_id: data?.campaign_id || false,
      // medium_id: data?.medium_id || false,
      // source_id: data?.source_id || false,
      // signed_by: data?.signed_by || false,
      // signed_on: data?.signed_on || false,
      // signature: data?.signature || false,
      // __last_update: data?.__last_update || false,
      // message_follower_ids: data?.message_follower_ids || [],
      // activity_ids: data?.activity_ids || [],
      // message_ids: data?.message_ids || [],
    };

    return getFormattedResponse({ payload, formFieldsList });
  };

  const handleAddSaleOrder = async (values) => {
    const payload = getPayload(values);
    let response = await create({
      payload,
      context,
      company_id,
      model: "sale.order",
    });
    response = JSON.parse(response);
    if (response?.result) {
      handleCloseModal();
    }
    return response;
  };

  const getOrderLine = (oldPayload, newPayload) => {
    const mySet = new Set();
    const temp = [...newPayload, ...oldPayload];
    temp.forEach((order) => {
      mySet.add(order[1]);
    });

    // old payload objects
    let oldPayloadObjects = {};
    oldPayload?.forEach((order) => {
      oldPayloadObjects[order[1]] = order[2];
    });
    // new payload objects
    let newPayloadObjects = {};
    newPayload?.forEach((order) => {
      newPayloadObjects[order[1]] = order[2];
    });
    const order_line = [];
    mySet.forEach((key) => {
      const oldData = oldPayloadObjects[key];
      const newData = newPayloadObjects[key];
      if (oldData && newData) {
        if (JSON.stringify(oldData) === JSON.stringify(newData)) {
          order_line.push([4, key, false]);
        } else {
          order_line.push([1, key, newData]);
        }
      } else if (oldData) {
        order_line.push([2, key, false]);
      } else if (newData) {
        order_line.push([0, key, newData]);
      }
    });

    return order_line;
  };
  const handleEditSaleOrder = async (values) => {
    const newChanges = {};
    const oldPayload = getPayload(previousInputs);
    const newPayload = getPayload(values);
    Object.keys(newPayload).forEach((key) => {
      if (JSON.stringify(newPayload[key]) != JSON.stringify(oldPayload[key])) {
        newChanges[key] = newPayload[key];
      }
    });

    if (Object.keys(newChanges).length === 0) {
      handleCloseModal();
      return false;
    }
    if (newChanges?.order_line) {
      const order_line = getOrderLine(
        oldPayload.order_line,
        newPayload.order_line
      );
      newChanges.order_line = order_line;
    }

    let response = await write({
      id: formData.id,
      change: { ...newChanges },
      company_id,
      context,
      model: "sale.order",
    });
    response = JSON.parse(response);
    if (response.result) {
      handleCloseModal();
    }
    return response;
  };

  const handleSubmit = async (...args) => {
    setIsSubmitting(true);
    let response = {};
    let successMessage = "Order Created Successfully";
    if (view === "edit") {
      successMessage = "Order Edited Successfully";
      response = await handleEditSaleOrder(...args);
    } else if (view === "add") {
      response = await handleAddSaleOrder(...args);
    }
    setIsSubmitting(false);
    handleResponse({
      response,
      setMetaData,
      setTitle,
      successMessage,
    });
  };

  const fetchSaleDetail = async (change) => {
    if (!selectedOrder) {
      setIsLoading(false);
      return false;
    }

    let response = await read({
      id: selectedOrder,
      context,
      company_id,
      change: [...change, "invoice_ids"],
      model: "sale.order",
    });
    response = JSON.parse(response)?.result?.[0];

    let order_line = [];
    const orderLinesOptions = { product: [] };
    if (response?.order_line?.length > 0) {
      let orderLineResponse = await read({
        id: response?.order_line,
        company_id,
        context,
        change: ORDER_LINE_DETAIL_KEYS,
        model: "sale.order.line",
      });

      orderLineResponse = JSON.parse(orderLineResponse);
      order_line = orderLineResponse?.result.map((item) => {
        orderLinesOptions.product = [
          ...orderLinesOptions.product,
          item.product_id,
        ];

        return {
          ...item,
          company_id,
          currency_id: item.currency_id?.[0] || false,
          product_id: item.product_id[0],
          name: item.product_id[1],
          product_template_id: item?.product_template_id?.[0],
          product_uom: item?.product_uom?.[0],
          price_unit: item.price_unit,

          product_uom_qty: item?.product_uom_qty || 0,
          tax_id: item?.tax_id?.[0] || "",
          discount: item?.discount || 0,
        };
      });
    }
    let inputList = {
      ...response,
      order_line,
      partner_id: response?.partner_id?.[0] || "",
      pricelist_id: response?.pricelist_id?.[0] || "",
      payment_term_id: response?.payment_term_id?.[0] || "",
      partner_invoice_id: response?.partner_invoice_id?.[0] || "",
      partner_shipping_id: response?.partner_shipping_id?.[0] || "",

      warehouse_id: response?.warehouse_id?.[0] || false,

      // extra Data
      additionalOptions: {
        warehouse: response?.warehouse_id || [],
        partner: response?.partner_id || [],
        pricelist: response?.pricelist_id || [],
        payment_term: response?.payment_term_id || [],
        partner_invoice: response?.partner_invoice_id || [],
        partner_shipping: response?.partner_shipping_id || [],
        ...orderLinesOptions,
      },
    };

    setFormData({ ...inputList });
    setPreviousInputs({ ...inputList });
    setIsLoading(false);
    return inputList;
  };
  const fetchData = async () => {
    if (selectedOrder) {
      setView("view");
    } else {
      setView("add");
    }
    let loadViewResponse = await loadViewGeneral({
      context,
      model: "sale.order",
    });

    loadViewResponse =
      getLoadViewsData({
        fieldsObject:
          { ...loadViewResponse?.result?.fields_views?.form?.fields } || null,
      }) || ORDER_LINE_DETAIL_KEYS;
    setFormFieldsList(loadViewResponse);
    if (!loadViewResponse) return;
    const response = await fetchSaleDetail(loadViewResponse);

    if (!response) return;
    const {
      partner = "",
      partner_invoice = "",
      partner_shipping = "",
      payment_term = "",
      pricelist = "",
      product = "",
      warehouse = "",
    } = response.additionalOptions;

    findAndAddOption({
      availableOptions: activeCustomersList,
      incomingOption: partner,
      setAvailableOptions: setActiveCustomersList,
    });
    findAndAddOption({
      availableOptions: warehouseList,
      incomingOption: warehouse,
      setAvailableOptions: setWarehouseList,
    });
    findAndAddOption({
      availableOptions: activeCustomersList,
      incomingOption: partner_invoice,
      setAvailableOptions: setActiveCustomersList,
    });
    findAndAddOption({
      availableOptions: activeCustomersList,
      incomingOption: partner_shipping,
      setAvailableOptions: setActiveCustomersList,
    });
    findAndAddOption({
      availableOptions: paymentTerms,
      incomingOption: payment_term,
      setAvailableOptions: setPaymentTerms,
    });
    findAndAddOption({
      availableOptions: priceList,
      incomingOption: pricelist,
      setAvailableOptions: setPriceList,
    });
    if (product) {
      product.forEach((item) => {
        findAndAddOption({
          availableOptions: productsList,
          incomingOption: item,
          setAvailableOptions: setProductsList,
        });
      });
    }
    setIsLoading(false);
    return response;
  };
  useEffect(() => {
    fetchData();
    handleCustomSearch({
      model: "account.tax",
      setState: setTaxList,
      args: [
        ["type_tax_use", "=", "sale"],
        ["company_id", "=", company_id],
      ],
    });
  }, []);

  useEffect(() => {
    if ((view === "edit" && formData.additionalOptions) || view === "add") {
      const customersStaticList = [];
      const {
        partner = "",
        partner_invoice = "",
        partner_shipping = "",
        payment_term = "",
        pricelist = "",
        product = "",
        warehouse,
      } = formData?.additionalOptions || {};
      if (partner) customersStaticList.push(partner);
      if (partner_invoice) customersStaticList.push(partner_invoice);
      if (partner_shipping) customersStaticList.push(partner_shipping);
      handleCustomSearch({
        model: "res.partner",
        setState: setActiveCustomersList,
        staticOptions: customersStaticList || [],
      });
      handleCustomSearch({
        model: "stock.warehouse",
        setState: setWarehouseList,
        staticOptions: warehouse ? [warehouse] : [],
      });
      handleCustomSearch({
        model: "product.product",
        setState: setProductsList,
        staticOptions: product || [],
        args: [
          ["sale_ok", "=", true],
          "|",
          ["company_id", "!=", false],
          ["company_id", "=", company_id],
        ],
      });
      handleCustomSearch({
        model: "account.payment.term",
        setState: setPaymentTerms,
        staticOptions: payment_term ? [payment_term] : [],
      });
      handleCustomSearch({
        model: "product.pricelist",
        setState: setPriceList,
        staticOptions: pricelist ? [pricelist] : [],
      });
    }
  }, [view]);

  const disableInputs = useMemo(() => view === "view", [view]);

  return (
    <>
      <ConfirmationModal />
      <Formik
        enableReinitialize
        initialValues={formData}
        validationSchema={newSaleOrderValidationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, setFieldValue, errors }) => (
          <Form style={{ maxWidth: "900px", height: "100%", padding: "12px" }}>
            <FormContainer className="row">
              <div className="row p-0 justify-content-between align-items-center">
                <div className="col">
                  <h3
                    className="me-2 mb-2 "
                    style={{
                      fontFamily: "Inter",
                      color: "#323B4B",
                      fontWeight: 600,
                    }}
                  >
                    {!selectedOrder && t["Create New Sales Order"]}
                    {selectedOrder && view === "edit" && t["Edit Sales Order"]}
                    {selectedOrder && view === "view" && t["Sales Order"]}
                  </h3>
                </div>
                {view === "view" && (
                  <div className="col d-flex justify-content-end p-0">
                    <SVGButton
                      icon={editIcon}
                      onClick={() => {
                        setActiveTab(0);
                        setView("edit");
                      }}
                      className="me-2"
                    />
                  </div>
                )}
              </div>

              <LoaderWrapper height="70vh" width="900px" isLoading={isLoading}>
                <div className="col-md-6">
                  <FormikSelect
                    searchFromApi
                    // disabled={disableInputs}
                    name="partner_id"
                    options={activeCustomersList}
                    label={t["Customer"]}
                    handleSearch={({ ...args }) =>
                      handleCustomSearch({ ...args, model: "res.partner" })
                    }
                    onChange={(option, { name }) => {
                      handleChangeCustomer({
                        option,
                        name,
                        setFieldValue,
                        values,
                      });
                    }}
                  />
                </div>
                <div className="col-md-6">
                  <FormikInput
                    disabled={disableInputs}
                    type="date"
                    name="validity_date"
                    label={t["Expiration"]}
                  />
                </div>
                <div className="col-md-6">
                  <FormikSelect
                    disabled={disableInputs}
                    name="partner_invoice_id"
                    options={activeCustomersList}
                    label={t["Invoice Address"]}
                    handleSearch={({ ...args }) =>
                      handleCustomSearch({ ...args, model: "res.partner" })
                    }
                  />
                </div>
                <div className="col-md-6">
                  <FormikSelect
                    disabled={disableInputs}
                    name="pricelist_id"
                    options={priceList}
                    label={t["Pricelist"]}
                    handleSearch={({ ...args }) =>
                      handleCustomSearch({
                        ...args,
                        model: "product.pricelist",
                      })
                    }
                  />
                </div>
                <div className="col-md-6">
                  <FormikSelect
                    disabled={disableInputs}
                    name="partner_shipping_id"
                    options={activeCustomersList}
                    label={t["Delivery Address"]}
                    handleSearch={({ ...args }) =>
                      handleCustomSearch({ ...args, model: "res.partner" })
                    }
                  />
                </div>
                <div className="col-md-6">
                  <FormikSelect
                    disabled={disableInputs}
                    name="payment_term_id"
                    options={paymentTerms}
                    label={t["Payment Terms"]}
                    handleSearch={({ ...args }) =>
                      handleCustomSearch({
                        ...args,
                        model: "account.payment.term",
                      })
                    }
                  />
                </div>
                <div className="col-md-6  mb-3">
                  <FormikInput
                    disabled={disableInputs}
                    type="text"
                    name="paymentStatus"
                    label={t["Payment Status"]}
                  />
                </div>
                <div className="col-md-6  mb-3">
                  <FormikSelect
                    disabled={disableInputs}
                    options={warehouseList}
                    name="warehouse_id"
                    label={t["Warehouse"]}
                    handleSearch={({ ...args }) =>
                      handleCustomSearch({ ...args, model: "stock.warehouse" })
                    }
                  />
                </div>
                <nav>
                  <div className="nav nav-tabs" id="nav-tab" role="tablist">
                    <button
                      className={`nav-link ${activeTab === 0 ? "active" : ""}`}
                      onClick={() => handleTabClick(0)}
                      type="button"
                    >
                      {t["Order Lines"]}
                    </button>
                    {/* <button
                      type="button"
                      className={`nav-link ${activeTab === 1 ? "active" : ""}`}
                      onClick={() => handleTabClick(1)}
                    >
                      {t["Optional Product"]}
                    </button>
                    <button
                      type="button"
                      className={`nav-link ${activeTab === 2 ? "active" : ""}`}
                      onClick={() => handleTabClick(2)}
                    >
                      {t["Other Info"]}
                    </button> */}

                    {view === "view" && (
                      <>
                        {values.delivery_count > 0 && (
                          <button
                            className={`nav-link ${
                              activeTab === 3 ? "active" : ""
                            }`}
                            onClick={() => handleTabClick(3)}
                            type="button"
                            disabled={values.delivery_count === 0}
                          >
                            {t["Delivery"]} ({values?.delivery_count || 0})
                          </button>
                        )}
                        <button
                          className={`nav-link ${
                            activeTab === 4 ? "active" : ""
                          }`}
                          onClick={() => handleTabClick(4)}
                          type="button"
                          // disabled={values.invoice_count === 0}
                        >
                          {t["Invoices"]} ({values?.invoice_count || 0})
                        </button>
                      </>
                    )}
                  </div>
                </nav>
                <div className="tab-content" id="nav-tabContent">
                  <div
                    className={`tab-pane fade overflow-auto show active`}
                    id="nav-home"
                    role="tabpanel"
                    type="button"
                    aria-labelledby="nav-home-tab"
                    tabIndex="0"
                  >
                    {activeTab === 0 && (
                      <FieldArray
                        name="order_line"
                        render={() => {
                          return (
                            <Orderlines
                              keyName="order_line"
                              isLoadingChange={isLoadingChange}
                              handleSearch={handleCustomSearch}
                              productList={productsList}
                              taxList={taxList}
                              formData={formData}
                              handleChangeProduct={handleChangeProduct}
                              validations={validations}
                              setValidations={setValidations}
                              disabled={disableInputs}
                            />
                          );
                        }}
                      />
                    )}

                    {activeTab === 1 && <OptionalProducts />}

                    {activeTab === 2 && <OtherInfo />}

                    {activeTab === 3 && (
                      <DeliveryInfo
                        selectedOrder={selectedOrder}
                        selectedSaleOrderDetail={formData}
                        deliveryOrders={deliveryOrders}
                        setDeliveryOrders={setDeliveryOrders}
                        fetchData={fetchData}
                      />
                    )}

                    {activeTab === 4 && (
                      <OrderInvoices
                        selectedOrder={selectedOrder}
                        selectedSaleOrderDetail={formData}
                        fetchData={fetchData}
                        invoices={invoices}
                        setInvoices={setInvoices}
                      />
                    )}
                  </div>
                </div>

                <CalculationContainer className="mt-3 mb-3 d-flex flex-column flex-md-row">
                  <FormikInput
                    textArea
                    disabled={disableInputs}
                    name="note"
                    placeholder={t["Terms and Conditions"]}
                    className="termsandConditions w-50"
                    style={{
                      width: "350px",
                      border: "2px solid rgb(243, 243, 243)",
                      margin: "6px 2px 2px",
                      padding: "2px",
                      color: "rgb(176, 183, 195)",
                      height: "130px",
                      backgroundColor: "#F5F5F5",
                    }}
                  />

                  <div className="calculation_div  d-flex justify-content-end w-50">
                    {/* <div className="coupan">
                      <div className="coupan_prmo_div">{t["Coupon"]}</div>
                      <div className="coupan_prmo_div">{t["Promotions"]}</div>
                    </div> */}
                    <TotalInfo />
                  </div>
                </CalculationContainer>
                {!disableInputs && (
                  <FormikSubmitButtons handleCloseModal={handleCloseModal} />
                )}
              </LoaderWrapper>
            </FormContainer>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default NewSaleForm;
